import React from 'react'
import { GetFormat, useGet } from 'sharedKernel/api'
import { trans } from 'sharedKernel/i18n'
import { HubCompanyDashboardStatsCard } from '../StatsCard'
import { HubCompanyChallengeDashboardResolverStatsApiResult } from './contracts'

export const HubCompanyDashboardResolverCounter = (): JSX.Element => {
  const labels = {
    statsName: trans('Soluções'),
    statsDescription: trans('Submetidos'),
    statsInfo: trans('Total de ideias submetidas para seus eventos')
  }

  const statsProps: any = {
    name: labels.statsName,
    count: 0,
    description: labels.statsDescription,
    info: labels.statsInfo,
    cardLabel: {
      icon: ['fas', 'user-group'],
      color: 'var(--orange)',
      background: 'var(--orange-light)',
      size: '2x'
    }
  }

  const request: GetFormat = {
    url: '/v1/hub/company/solution/dashboard/stats'
  }
  const { data, isError, isLoading, isFetching } = useGet<HubCompanyChallengeDashboardResolverStatsApiResult>(
    request,
    'idea-stats-get'
  )
  if (isFetching || isLoading || isError) {
    return <HubCompanyDashboardStatsCard {...statsProps} />
  }

  if (data.data.submittedIdeas === null || data.data.submittedIdeas === undefined) {
    return <HubCompanyDashboardStatsCard {...statsProps} />
  }

  statsProps.count = data.data.submittedIdeas
  return <HubCompanyDashboardStatsCard {...statsProps} />
}
